import React from 'react';
import { ScaleQuestion as QuestionType } from '../types/assessment';
import { ArrowLeft } from 'lucide-react';
interface ScaleQuestionProps {
  question: QuestionType;
  onAnswer: (value: number) => void;
  onBack?: () => void;
  canGoBack?: boolean;
  previousAnswer?: number;
}
export function ScaleQuestion({
  question,
  onAnswer,
  onBack,
  canGoBack = false,
  previousAnswer
}: ScaleQuestionProps) {
  return <div className="max-w-2xl mx-auto px-4 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-287">
      {canGoBack && onBack && <button onClick={onBack} className="flex items-center text-[#6B7280] hover:text-[#E10600] transition-colors mb-8 group" data-id="element-288">
          <ArrowLeft className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-289" />
          <span className="text-sm font-bold uppercase tracking-widest" data-id="element-290">
            Back
          </span>
        </button>}

      <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-16 text-center leading-none tracking-wide" data-id="element-291">
        {question.text}
      </h2>

      <div className="flex flex-col items-center space-y-10" data-id="element-292">
        <div className="flex justify-between w-full max-w-lg px-2 text-xs font-bold text-[#6B7280] uppercase tracking-widest" data-id="element-293">
          <span data-id="element-294">Strongly Disagree</span>
          <span data-id="element-295">Strongly Agree</span>
        </div>

        <div className="flex justify-between items-center w-full max-w-lg gap-2" data-id="element-296">
          {[1, 2, 3, 4, 5].map(value => {
          const isSelected = previousAnswer === value;
          return <button key={value} onClick={() => onAnswer(value)} className="group flex flex-col items-center focus:outline-none" aria-label={`Rate ${value} out of 5`} data-id="element-297">
                <div className={`
                    w-12 h-12 md:w-16 md:h-16 rounded-md border-2 flex items-center justify-center text-2xl font-display font-bold transition-all duration-200
                    ${isSelected ? 'border-[#E10600] bg-[#E10600] text-white scale-110 shadow-[0_0_20px_rgba(225,6,0,0.4)]' : 'border-[#2a2f3b] bg-[#111318] text-[#6B7280] group-hover:border-[#E10600] group-hover:text-[#E10600] group-hover:scale-110 group-hover:shadow-[0_0_15px_rgba(225,6,0,0.3)]'}
                    focus:ring-2 focus:ring-[#E10600] focus:ring-offset-2 focus:ring-offset-[#0B0F14]
                  `} data-id="element-298">
                  {value}
                </div>
                <div className={`h-1 w-8 rounded-full mt-4 transition-colors ${isSelected ? 'bg-[#E10600] shadow-[0_0_10px_rgba(225,6,0,0.5)]' : 'bg-transparent group-hover:bg-[#E10600] shadow-[0_0_10px_rgba(225,6,0,0.5)]'}`} data-id="element-299" />
              </button>;
        })}
        </div>
      </div>
    </div>;
}